;
(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router = APP.module('Router');
	var Model = APP.module('Model');
	var View = APP.module('View');
	var Layout = APP.module('Layout');
	var Collection = APP.module('Collection');

	Controller.TippingClubs = function () {

	};

	_.extend(
		Controller.TippingClubs.prototype,
		Controller.Tipping.prototype, {

			getTippingData: function () {
				this.tipping_data = new Model.Tipping();
				this.gauntlet_data = new Model.Gauntlet();
			},

			gamesList: function () {
				this.start();
				this.getTippingData();

				var controls = new View.TippingControls({
						rounds: this.rounds,
						round_id: false
					}),
					tips = new View.TippingTips({
						round_id: false,
						model: this.tipping_data,
						rounds: this.rounds,
						squads: this.squads,
						venues: this.venues,
						formGuide: new Model.TippingFormGuide(),
						collection: new Collection.Tipping(),
						trend: new Collection.TippingRoundStats()
					});

				this.tippingLayout.controls.show(controls);
				this.tippingLayout.tips.show(tips);
				this.tippingLayout.gamebar.show(this.getGamebar());
			},

			gauntlet: function () {
				this.start();
				this.getTippingData();
				var controls = new View.TippingControls({
						rounds: this.rounds,
						round_id: false,
						gauntlet_start_round: 7,
						gauntlet_end_round: 24,
					}),
					tips = new View.TippingGauntlet({
						round_id: false,
						model: this.gauntlet_data,
						rounds: this.rounds,
						squads: this.squads,
						venues: this.venues,
						formGuide: new Model.TippingFormGuide(),
						collection: new Collection.Tipping()
					});

				var widgets = ['AflClubsLadder'];
				if (this.getUserAge() >= 18) {
					widgets = ['Promo', 'AflClubsLadder'];
				}

				this.view.aside.show(new Layout.Sidebar({
					widgets_list: widgets,
					widgets_options: {
						rounds: this.rounds,
						squads: this.squads,
						collection: new Collection.TippingRoundStats(),
						ladderCollection: new Collection.TippingLadder()
					}
				}));

				this.tippingLayout.controls.show(controls);
				this.tippingLayout.tips.show(tips);
				this.tippingLayout.gamebar.show(this.getGamebar());

				return this;
			},

			getUserAge: function () {
				var user_number = localStorage.getItem('User').split(',').slice(-1)[0].trim();
				var user_object = JSON.parse(localStorage.getItem('User-' + user_number));

				var today = new Date();
				var birthDate = new Date(user_object.birthday);
				var age = today.getFullYear() - birthDate.getFullYear();
				var m = today.getMonth() - birthDate.getMonth();
				if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
					age--;
				}
				return age;
			},

			getWidgets: function () {

				var widgets = ['AflClubsLadder', 'AflClubsGauntlet', 'AflClubsPick5'];
				if (this.getUserAge() >= 18) {
					widgets = ['Promo', 'AflClubsLadder', 'AflClubsGauntlet', 'AflClubsPick5'];
				}

				return new Layout.Sidebar({
					widgets_list: widgets,
					widgets_options: {
						rounds: this.rounds,
						squads: this.squads,
						collection: new Collection.TippingRoundStats(),
						ladderCollection: new Collection.TippingLadder()
					}
				});
			},

		});


	APP.on('start', function () {
		new Router.Tipping({
			controller: new Controller.TippingClubs()
		});
	});

}(window, APP, Backbone, Marionette, $, _));